export const effectValues = {
  buttonRaised: [
    '0 16px 38px -6px rgba(174, 182, 204, 0.55)',
    '0 6px 18px -4px rgba(174, 182, 204, 0.4)',
    '-6px -6px 16px 0 rgba(255, 255, 255, 0.9)',
  ].join(', '),
} as const

export const effectTokens = {
  shadows: {
    assiduousButtonRaised: { value: effectValues.buttonRaised },
  },
}
